import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { Context } from './types'

/** Space record functional usage API, for fetching and updating functional usage */
@ngCore.Injectable()
export class Api {
  /** Gets functional usage for a space record */
  public get(
    context: Context,
  ): rxjs.Observable<ents.extra.space.Record.FunctionalUsage | undefined> {
    return gql.queries.SpaceRecordFunctionalUsage.executor(context)
  }
  /** Updates functional usage for a space record */
  public update({
    context,
    updates,
  }: {
    context: Context
    updates: ents.extra.space.Record.FunctionalUsage.Update
  }): rxjs.Observable<ents.extra.space.Record.FunctionalUsage | undefined> {
    return gql.mutations.updateSpaceRecordFunctionalUsage.executor({
      ...context,
      update: gql.inputs.recordUpdates.TRANSFORMER.getGqlFrom(updates),
    })
  }
}
